module.exports = __webpack_public_path__ + "static/media/ticket-types.36fbc4e9.png";